import { render, staticRenderFns } from "./PTRAndPTSCalculator.vue?vue&type=template&id=14881843&scoped=true&"
import script from "./PTRAndPTSCalculator.vue?vue&type=script&lang=js&"
export * from "./PTRAndPTSCalculator.vue?vue&type=script&lang=js&"
import style0 from "./PTRAndPTSCalculator.vue?vue&type=style&index=0&id=14881843&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14881843",
  null
  
)

export default component.exports